import { config } from '../config/config';

export const TRPC_API_URL = `${config.fymApiURL(true)}trpc`;
